export default __webpack_public_path__ + "static/media/aretha.b908ff62.jpg";